/**
 * Used for property name enforcement for form fields and table columns that use
 * object keys for value lookups.
 */
export const nameof = <T>(key: keyof T & string) => {
    return key;
};